import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import MyChatComponent from './MyChatComponent';
import MyUserContext from '../myUserContext';
import TagsInput from './TagsInput';
import { Drawer } from "@mantine/core";

const ArtEventDropdown = ({ eventId, onClose, language, eventType = "artEvent", initialArtEvent = null, art = null }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate();
  const [artEvent, setArtEvent] = useState(initialArtEvent);

  useEffect(() => {
    if (initialArtEvent) return;
    const url = eventType === 'recommendation' ? `/recommendations/${eventId}` : `/artEvents/${eventId}`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (eventType === 'recommendation') {
          setArtEvent({
            event: response.data.recommendation,
            art: response.data.art,
            chat: response.data.chat,
            fromUser: response.data.fromUser,
            toUser: response.data.toUser,
          });
        } else {
          setArtEvent({
            event: response.data.event,
            art: response.data.art,
            chat: response.data.chat,
            eventOwnerUserName: response.data.eventOwnerUserName,
            eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl,
          });
        }
      })
      .catch((error) => console.error(error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!artEvent) {
    return null;
  }

  const artForHeader = art || artEvent.art;
  const isOwner =
    eventType === 'artEvent' &&
    myUser &&
    artEvent.event &&
    myUser.myUserInfo?.myUserId === artEvent.event.userID;

  return (
    <Drawer
      opened
      onClose={onClose}
      position="bottom"
      size="75vh"
      radius="md"
      padding="md"
      classNames={{ root: 'art-page-drawer' }}
      title={
        <span style={{ fontWeight: 700 }}>
          {language === "ru" ? "Произведение в моей библиотеке " : "Art in my library "}
          <span
            onClick={() => navigate(`/artEvents/${eventId}`)}
            className="cursor-pointer hover:underline"
            style={{ fontWeight: 400 }}
          >
            {language === "ru" ? "(развернуть)" : "(expand)"}
          </span>
        </span>
      }
      styles={{
        title: { flex: 1, textAlign: 'center' },
        // Make the drawer body a flex column with a definite height
        // (75vh minus title bar + body padding). The chat wrapper
        // below is flex-1 min-h-0 so it fills whatever's left after
        // the thumbnail + tag editor, and the chat itself with
        // fillHeight={true} takes 100% of that — no dead gap under
        // the input row.
        body: {
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(75vh - 82px)',
          overflow: 'hidden',
        },
      }}
    >
      {artForHeader && (
        <div className="flex justify-center my-2">
          <img
            className="object-cover rounded-lg max-w-[100px]"
            src={artForHeader.thumbnailUrl}
            alt={artForHeader.name || "Art Thumbnail"}
          />
        </div>
      )}
      {isOwner && (
        <div className="flex justify-center mb-2">
          <TagsInput
            key={`overlay-tags-${artEvent.event.id}`}
            language={language}
            editable={true}
            artCategory={artForHeader?.category}
            initialTags={artEvent.event.eventTags?.map((t) => t.name) || []}
            initialTagObjects={artEvent.event.eventTags || []}
            onTagsChange={(actualTagNames) => {
              axiosInstance
                .post(`/artEvents/tag/${artEvent.event.id}/tag`, { tags: actualTagNames })
                .then((response) => {
                  setArtEvent((prev) => (prev ? { ...prev, event: response.data.event } : prev));
                })
                .catch((error) => console.error(error));
            }}
          />
        </div>
      )}
      <div className="flex-1 min-h-0">
        <MyChatComponent
          key={artEvent.event.chatId}
          chatId={artEvent.event.chatId}
          _userChatInfo={artEvent.chat}
          language={language}
          myUserInfo={myUser ? myUser.myUserInfo : null}
          chatOwnerInfo={{ type: eventType, id: artEvent.event.id }}
          isDropdown={true}
          fillHeight={true}
        />
      </div>
    </Drawer>
  );
};

export default ArtEventDropdown;
